import { createAsyncThunk } from '@reduxjs/toolkit';
import { configurationService } from '../../services';
import { getEnv } from '../../config';

const { applicationName } = getEnv();

const getConfiguration = () => createAsyncThunk('configuration/findOne', async () => configurationService.findOneConfig(applicationName));

export default {
  getConfiguration: getConfiguration(),
};
